import { render } from "./App.vue?vue&type=template&id=b926c49e&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=b926c49e&lang=scss"

import exportComponent from "/Users/rboss/repos/TRENZ/Kunden/KaRa/Mockup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__